import { useCallback, useState } from 'react';

export const useModals = (initialValues: Record<string, boolean>) => {
  const [modals, setModals] = useState<Record<string, boolean>>(initialValues);

  const openModal = useCallback((type: string) => () => setModals((prevState) => ({ ...prevState, [type]: true })), []);

  const closeModal = useCallback((type: string) => () => setModals((prevState) => ({ ...prevState, [type]: false })), []);

  return [modals, openModal, closeModal] as const;
};
